import {IcnBankFilled, IcnFingerprint, IcnQrCode} from "../../assets/icons";

import {cModalFormViewButton} from "../../utils";
import {AvailableBalance} from "../../utils/creditService";

import ModalFormWrapper from "../common/ModalFormWrapper";
import ModalFormViewButton from "../common/ModalFormViewButton";

interface HomeDrawCreditModalViewProps {
  onCloseModal: () => void;
  onClickStablecoin: () => void;
  onClickRamp: () => void;
  creditLine: AvailableBalance;
}

const ModalFormViewButtonList = (
  {
    onClickStablecoin,
    onClickRamp,
  }: {
    onClickStablecoin: () => void;
    onClickRamp: () => void;
  }): cModalFormViewButton[] => [
  {
    icon: <IcnQrCode />,
    title: "Transfer to wallet",
    description: "Send stablecoins to a wallet",
    onClick: onClickStablecoin,
    enabled: true,
  },
  {
    icon: <IcnBankFilled />,
    title: "Off-ramp to fiat currency",
    description: "Directly through our preferred partners",
    onClick: onClickRamp,
    enabled: false,
  },
];

function HomeDrawCreditModalView (
  {
    onCloseModal,
    onClickStablecoin,
    onClickRamp,
    creditLine
  }:HomeDrawCreditModalViewProps) {

  const buttons = ModalFormViewButtonList({ onClickStablecoin, onClickRamp });

  return (
    <>
      <ModalFormWrapper
        headerTitle="Select a method for more credit"
        hideBackButton
        onCloseModal={onCloseModal}
      >

        {buttons.map((btn, btnIdx) => (
          <ModalFormViewButton
            key={btnIdx}
            icon={btn.icon}
            title={btn.title}
            description={btn.description}
            onClick={btn.onClick}
            enabled={btn.enabled}
          />
        ))}

      </ModalFormWrapper>

      <div className="c-modal-footer">
        <small>
            <i><IcnFingerprint/></i>
          All transactions on Liquid Credit protected by enterprise-grade security.
        </small>
      </div>

    </>
  );
}

export default HomeDrawCreditModalView;